import { createReducer, on } from '@ngrx/store';
import { PairConfirmContainerActions, PairingApiActions, PairingSignalRActions } from './pairing.actions';
import { initialState, State } from './pairing.state';

export const pairingReducer = createReducer(
  initialState,
  on(
    PairConfirmContainerActions.verifyCodeRequested,
    (state, { code }): State => ({
      ...state,
      code,
      isEnrollmentCompleted: false,
      isEnrolling: false,
      isVerifyingCode: true,
      pairChallenge: undefined,
    })
  ),
  on(
    PairingApiActions.verifyCodeValid,
    (state, { pairChallenge }): State => ({
      ...state,
      isEnrollmentCompleted: false,
      isEnrolling: false,
      isVerifyingCode: false,
      isCodeValid: true,
      isCodeValidated: true,
      pairChallenge,
    })
  ),
  on(
    PairingApiActions.verifyCodeInvalid,
    (state): State => ({
      ...state,
      isEnrollmentCompleted: false,
      isEnrolling: false,
      isVerifyingCode: false,
      isCodeValid: false,
      isCodeValidated: true,
      pairChallenge: undefined,
    })
  ),
  on(
    PairingApiActions.verifyCodeError,
    (state, { error }): State => ({
      ...state,
      isEnrollmentCompleted: false,
      isEnrolling: false,
      isVerifyingCode: false,
      isCodeValid: false,
      isCodeValidated: false,
      pairChallenge: undefined,
      error,
    })
  ),
  on(
    PairConfirmContainerActions.enrollmentRequested,
    (state): State => ({
      ...state,
      isEnrollmentCompleted: false,
      isEnrolling: true,
    })
  ),
  on(PairingSignalRActions.enrollmentCompleted, (state, { challenge }): State => {
    if (state.pairChallenge === undefined) {
      return state;
    }

    if (challenge !== state.pairChallenge.challenge) {
      return state;
    }

    return {
      ...state,
      isEnrolling: false,
      isEnrollmentCompleted: true,
      pairChallenge: undefined,
    };
  })
);
